import { Component, ViewChild } from '@angular/core';
import { NavController, LoadingController, NavParams, ModalController, ToastController, AlertController } from 'ionic-angular';
import { Globals, Unit, ConvertedQuantity } from "../../../../../globals";
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationServices } from '../../../services';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { FormBuilder, FormGroup } from '@angular/forms';
import { StaticsServices } from '../../../../services/statics';
import { HttpClient, HttpParams } from '@angular/common/http';

@Component({
    selector: 'page-configuration-complements-create-list',
    templateUrl: 'configuration-complements-create-list.html'
})

export class ConfigurationComplementsCreateListPage {
    loading: boolean = true;
    // Flags to control checkbox state
    showIngredients = true;
    showArticles = true;
    // Combined list of ingredients and articles
    ingredientsAndArticles = [];

    selectedItems: any[] = [];
    selectedIngredient: any;
    selectedMeasurement: any = 'ud';
    selected_collapse: boolean = false;
    update_state: boolean = false;
    public form: FormGroup;
    type: any;
    dish: any;
    ingredient: any;
    product: any;
    variation: any;
    //datatable
    sorts = [
        { prop: 'name', dir: 'asc' }
    ];
    @ViewChild(DatatableComponent) table: DatatableComponent;
    ColumnMode = ColumnMode;
    config_msg = {
        emptyMessage: this.translate.instant('general-no-hay-datos'),
        totalMessage: this.translate.instant('general-total'),
        selectedMessage: this.translate.instant('general-seleccionado')
    };

    callback: any;
    searchText: string = '';

    constructor(public navCtrl: NavController,
        public globals: Globals,
        public loadingCtrl: LoadingController,
        public navParams: NavParams,
        public translate: TranslateService,
        public configurationServices: ConfigurationServices,
        public modalCtrl: ModalController,
        public fb: FormBuilder,
        private toastCtrl: ToastController,
        private alertCtrl: AlertController,
        private staticsServices: StaticsServices,
        private http: HttpClient) {

        this.callback = this.navParams.get('callback');
        this.update_state = this.navParams.get('update_state') || false;

        // Ensure values are not undefined
        this.variation = this.navParams.get('variation') || {};

        // Always initialize an empty form as fallback
        this.form = this.fb.group({
            name: [''],
            name_en: [''],
            name_fr: [''],
            name_de: [''],
            name_it: [''],
            name_ca: [''],
            measurement: [''],
            price: [0],
            quantity: [''],
            type: [''],
            uid_element: [''],
        });

        // Wait for data to load before initializing the form
        this.loadAndInitialize();
    }

    ngOnInit(): void {
        this.loadAndInitialize();
    }

    ionViewWillLeave() {
        this.configurationServices.variations_searchbar_text = '';
        this.configurationServices.variations_array_filtered = [...this.configurationServices.variations_array_tmp];
        this.configurationServices.showIngredients = true;
        this.configurationServices.showArticles = true;
    }

    async loadAndInitialize() {
        try {
            this.loading = true;

            // Cargar datos
            await this.configurationServices.getDishesProductsIngredients();
            await this.configurationServices.getListVariations();

            // Asegurar que los filtros estén activos
            this.configurationServices.showIngredients = true;
            this.configurationServices.showArticles = true;

            // Aplicar filtros y actualizar lista
            this.configurationServices.filterDishesProductsIngredients();
            this.ingredientsAndArticles = [...this.configurationServices.list_dishes_products_ingredients_filtered];

            // Si estamos en modo actualización, cargar datos específicos
            if (this.update_state && this.variation) {
                await this.getElementsContainingVariation();
            }

            // Inicializar formulario
            this.initializeForm();
        } catch (error) {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('general-error-cargando-datos'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        } finally {
            this.loading = false;
        }
    }

    initializeForm() {
        // Always initialize an empty form as fallback
        this.form = this.fb.group({
            name: [''],
            name_en: [''],
            name_fr: [''],
            name_de: [''],
            name_it: [''],
            name_ca: [''],
            measurement: [''],
            price: [0],
            quantity: [''],
            type: [''],
            uid_element: [''],
        });

        if (this.update_state && this.variation) {
            this.globals.GAtrackView(
                'Configuration',
                'Configuration - Variation - View ',
                this.globals.restaurant.email,
                'View',
                'View variation',
                'Configuration',
                ''
            );

            // Find the correct item using uid_element
            let selectedItem = this.configurationServices.list_dishes_products_ingredients.find(
                (item: any) => item.UID === this.variation.uid_element
            );

            // Set selected item if found
            this.selectedItems = selectedItem ? [selectedItem] : [];

            // Initialize the form with all language names
            this.form.patchValue({
                name: this.variation.name || '',
                name_en: this.variation.name_en || '',
                name_fr: this.variation.name_fr || '',
                name_de: this.variation.name_de || '',
                name_it: this.variation.name_it || '',
                name_ca: this.variation.name_ca || '',
                measurement: this.variation.measurement || '',
                price: this.variation.price !== undefined ? this.variation.price : 0,
                quantity: this.variation.quantity !== undefined ? this.variation.quantity : '',
                type: this.variation.type || '',
                uid_element: this.variation.uid_element || '',
            });

            // Update selected measurement for UI display
            this.selectedMeasurement = this.variation.measurement || '';
        }
    }

    async getElementsContainingVariation() {
        try {
            const params = new HttpParams()
                .set('uid', this.globals.restaurant_uid)
                .set('variation_uid', this.variation.UID);

            const res = await this.http.post(this.globals.analytics_path + 'get/elements-containing-variation', params, {}).toPromise();
            if (res && res['elements']) {
                this.configurationServices.dishes_products_array_tmp = res['elements'];
            }
        } catch (error) { }
    }

    changeValue(type: string) {
        if (type === 'ingredient') {
            this.configurationServices.showIngredients = !this.configurationServices.showIngredients;
        } else {
            this.configurationServices.showArticles = !this.configurationServices.showArticles;
        }
        this.configurationServices.filterDishesProductsIngredients(false);
    }

    stateColCss() {
        if (this.globals.platform_width === 'mobile') {
            let cssClasses = {
                'col-6': true
            }
            return cssClasses;
        } else {
            let cssClasses = {
                'col-auto': true
            }
            return cssClasses;
        }
    }

    searchElements(value) {
        if (value) {
            // Primero filtramos por los checkboxes (ingredientes/artículos)
            this.configurationServices.filterDishesProductsIngredients(false);

            // Luego filtramos por el texto de búsqueda (nombre y tags)
            this.ingredientsAndArticles = this.configurationServices.list_dishes_products_ingredients_filtered.filter(item => {
                const name = this.globals.nameNotEsLang(item).toLowerCase();
                const searchValue = value.toLowerCase();
                
                // Buscar en el nombre
                const nameMatch = name.includes(searchValue);
                
                // Buscar en las categorías (tags)
                let tagsMatch = false;
                if (item.tags && item.tags.length > 0) {
                    tagsMatch = item.tags.some(tag => 
                        tag.toLowerCase().includes(searchValue)
                    );
                }
                
                // Mostrar si coincide con nombre o tags
                return nameMatch || tagsMatch;
            });
        } else {
            // Si no hay texto de búsqueda, solo aplicamos los filtros de checkboxes
            this.configurationServices.filterDishesProductsIngredients();
            this.ingredientsAndArticles = [...this.configurationServices.list_dishes_products_ingredients_filtered];
        }
    }

    toggleFilter(type: 'ingredients' | 'articles') {
        if (type === 'ingredients') {
            this.configurationServices.showIngredients = !this.configurationServices.showIngredients;
        } else {
            this.configurationServices.showArticles = !this.configurationServices.showArticles;
        }

        // Aplicamos los filtros y actualizamos la lista
        this.configurationServices.filterDishesProductsIngredients(false);
        this.ingredientsAndArticles = [...this.configurationServices.list_dishes_products_ingredients_filtered];

        // Si hay un texto de búsqueda, lo aplicamos de nuevo
        const searchInput = document.querySelector('input[type="text"]') as HTMLInputElement;
        if (searchInput && searchInput.value) {
            this.searchElements(searchInput.value);
        }
    }

    onSort(event) {
        var list_array = this.ingredientsAndArticles;

        switch (event.column.name) {
            case 'name':
                if (event.newValue == 'asc') {
                    list_array.sort((a, b) => this.globals.nameLangSelectIngredient(a).localeCompare(this.globals.nameLangSelectIngredient(b)));
                } else {
                    list_array.sort((a, b) => this.globals.nameLangSelectIngredient(b).localeCompare(this.globals.nameLangSelectIngredient(a)));
                }
                break;
        }

        this.ingredientsAndArticles = list_array;
    }

    submit() {
        if (this.update_state) {
            this.update();
        } else {
            this.insert();
        }
    }

    insert() {
        // Obtener el nombre en el idioma principal según el idioma del restaurante
        const restaurantLang = this.globals.restaurant.lang;
        const nameField = restaurantLang === 'es' ? 'name' : `name_${restaurantLang}`;
        const mainName = this.form.value[nameField] ? this.form.value[nameField].trim() : '';

        // Si no hay nombre en el idioma principal, no continuar
        if (!mainName) {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('general-introduce-nombre-idioma') + ' ' + this.globals.getLanguageName(restaurantLang),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
            return;
        }

        const converted: ConvertedQuantity = this.form.value.quantity
            ? this.globals.autoConvertQuantity(parseFloat(this.form.value.quantity), this.form.value.measurement as Unit)
            : { value: null, unit: this.form.value.measurement || 'ud.' };

        // En la creación, respetamos los nombres introducidos en cada idioma
        const dataToSave: any = {
            UID_RESTAURANT: this.globals.restaurant_uid,
            name: this.form.value.name ? this.form.value.name.trim() : mainName,
            name_en: this.form.value.name_en ? this.form.value.name_en.trim() : mainName,
            name_fr: this.form.value.name_fr ? this.form.value.name_fr.trim() : mainName,
            name_de: this.form.value.name_de ? this.form.value.name_de.trim() : mainName,
            name_it: this.form.value.name_it ? this.form.value.name_it.trim() : mainName,
            name_ca: this.form.value.name_ca ? this.form.value.name_ca.trim() : mainName,
            measurement: converted.unit || '',
            type: this.form.value.type || '',
            price: this.form.value.price !== undefined ? this.form.value.price : 0,
            quantity: converted.value !== null ? converted.value : null,
            uid_element: this.form.value.uid_element || null,
        };

        this.configurationServices.afs.collection('variations').add(dataToSave).then(doc => {
            const newItem = { ...dataToSave, UID: doc.id };

            this.configurationServices.list_dishes_products_ingredients.push(newItem);

            this.configurationServices.list_dishes_products_ingredients = [...this.configurationServices.list_dishes_products_ingredients];

            if (this.callback) {
                this.callback(newItem);
            }

            this.navCtrl.pop();
        }).catch(error => {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('general-error-guardando-datos'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        });
    }

    update() {
        // Obtener el nombre en el idioma principal según el idioma del restaurante
        const restaurantLang = this.globals.restaurant.lang;
        const nameField = restaurantLang === 'es' ? 'name' : `name_${restaurantLang}`;
        const mainName = this.form.value[nameField] ? this.form.value[nameField].trim() : '';

        // Si no hay nombre en el idioma principal, no continuar
        if (!mainName) {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('general-introduce-nombre-idioma') + ' ' + this.globals.getLanguageName(restaurantLang),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
            return;
        }

        const converted: ConvertedQuantity = this.form.value.quantity
            ? this.globals.autoConvertQuantity(parseFloat(this.form.value.quantity), this.form.value.measurement as Unit)
            : { value: null, unit: this.form.value.measurement || 'ud.' };

        // En la actualización, mantenemos los nombres específicos de cada idioma
        const dataToUpdate: any = {
            name: restaurantLang === 'es' ? mainName : this.form.value.name.trim() || '',
            name_en: restaurantLang === 'en' ? mainName : this.form.value.name_en.trim() || '',
            name_fr: restaurantLang === 'fr' ? mainName : this.form.value.name_fr.trim() || '',
            name_de: restaurantLang === 'de' ? mainName : this.form.value.name_de.trim() || '',
            name_it: restaurantLang === 'it' ? mainName : this.form.value.name_it.trim() || '',
            name_ca: restaurantLang === 'ca' ? mainName : this.form.value.name_ca.trim() || '',
            measurement: converted.unit || '',
            type: this.form.value.type || '',
            price: this.form.value.price !== undefined ? this.form.value.price : 0,
            quantity: converted.value !== null ? converted.value : null,
            uid_element: this.form.value.uid_element || null,
        };

        this.configurationServices.afs.collection('variations').doc(this.variation.UID).update(dataToUpdate)
            .then(() => {
                let index = this.configurationServices.list_dishes_products_ingredients.findIndex(item => item.UID === this.variation.UID);
                if (index !== -1) {
                    this.configurationServices.list_dishes_products_ingredients[index] = {
                        ...this.configurationServices.list_dishes_products_ingredients[index],
                        ...dataToUpdate
                    };

                    this.configurationServices.list_dishes_products_ingredients = [...this.configurationServices.list_dishes_products_ingredients];
                }

                this.globals.GAtrackView(
                    'Configuration',
                    'Configuration - Variation - Name - Update ',
                    this.globals.restaurant.email,
                    'Create/Update',
                    'Update variation name',
                    'Configuration',
                    this.form.value[nameField]
                );

                this.staticsServices.changeStateStaticWait(true);
                this.navCtrl.pop();
            }).catch(error => {
                let toast = this.toastCtrl.create({
                    message: this.translate.instant('general-error-guardando-datos'),
                    duration: 3000,
                    position: 'bottom'
                });
                toast.present();
            });
    }

    delete() {
        let alert = this.alertCtrl.create({
            title: this.translate.instant('instant-eliminar-complemento'),
            message: this.translate.instant('instant-seguro-quieres-eliminarlo'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => {
                    }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        this.deleteVariation();
                    }
                }
            ]
        });
        alert.present();
    }

    async deleteVariation() {
        this.globals.GAtrackView('Configuration', 'Configuration - Variation - Delete ', this.globals.restaurant.email, 'Delete', 'Delete variation', 'Configuration', this.variation.name);
        //llamar statics
        this.deletesAndStatics(this.variation.UID);
        //borrar de firebase
        await this.configurationServices.afs.doc('variations/' + this.variation.UID).delete();
        this.navCtrl.pop();
    }

    async deletesAndStatics(uid) {
        this.staticsServices.changeStateStaticWait(true);
        this.staticsServices.addDeleteStaticToQueue(uid, 'delete_variation_update');
    }

    collapse() {
        this.selected_collapse = !this.selected_collapse;
    }

    // Method to handle item selection from the table
    clickElement(event) {
        if (event.type === 'click') {
            const selectedItem = event.row;
            this.selectedItems = [selectedItem];
            this.selectedMeasurement = selectedItem.measurement || '';

            // Actualizar el formulario con los datos del elemento seleccionado
            this.form.patchValue({
                type: selectedItem.type,
                uid_element: selectedItem.UID,
                measurement: selectedItem.measurement || ''
            });
        }
    }

    onQuantityChange(event: any) {
        const inputValue = parseFloat(event.target.value); // Ensure it's a float
        if (isNaN(inputValue)) return;

        const converted: ConvertedQuantity = this.globals.autoConvertQuantity(inputValue, this.selectedMeasurement);

        this.form.patchValue({
            quantity: converted.value,
            measurement: converted.unit
        });

        this.selectedMeasurement = converted.unit;
    }

    deleteElement(index: number) {
        if (index >= 0) {
            this.selectedItems.splice(index, 1); // Remove the selected item
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-complements/configuration-complements-create/configuration-complements-create-list/configuration-complements-create-list.ts